import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


export default class StartDialogDatePicker extends Component {


    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Sicherheitsabfrage</DialogTitle>
                <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Bist du sicher ?
                        </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Nein
                    </Button>
                        <Button onClick={this.props.openPicker} name="Start" color="primary" autoFocus>
                           Ja
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
